import { FormLabel, styled } from '@mui/material';

export const FormLabelStyled = styled(FormLabel)`
  align-self: flex-start;
  margin-bottom: 4px;
  margin-left: 16px;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.text.primary};
`;
